"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcLinkBlock = function (props) {
    var children = props.children;
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "rounded-0 mb-4 border-0", style: { backgroundColor: '#e8eef5' } },
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-4" },
            react_1.default.createElement("div", { className: "d-flex flex-row" }, children))));
};
exports.AcLinkBlock = AcLinkBlock;
exports.default = AcLinkBlock;
//# sourceMappingURL=AcLinkBlock.js.map